export { default } from "./IntercomProvider";
